import { missingNativeBuild } from "../nativeError";
function share(_items) {
  return Promise.reject(missingNativeBuild("Share.share"));
}
var Share = Object.freeze({
  share
});
export {
  Share
};
//# sourceMappingURL=unavailable.js.map
